module.exports = __webpack_public_path__ + "img/btn_signup_.902d47f3.png";